module.exports = __webpack_public_path__ + "static/media/IMG_6342.7960a888.JPG";